/**
 * Functions related to open modal functionality
 *
 * @return void
 *
 */

import {body, activeClass, hiddenClass, modalOpenClass} from './helpers';

export const modal = () => {
	const openModalBtn  = document.querySelectorAll( '.js-open-modal' );
	const closeModalBtn = document.querySelectorAll( '.js-close-modal' );
	const modal         = '.o-modal';

	/**
	 * Open modal trigger
	 */
	function openModalTrigger( el ) {
		el.preventDefault();
		const id = this.getAttribute( 'data-id' );

		document.querySelectorAll( modal ).forEach( ( item ) => item.classList.remove( activeClass ) );
		document.querySelector( modal + `[id="${id}"]` ).classList.add( activeClass );
		// body.classList.add( hiddenClass );
		body.classList.add( modalOpenClass );
	}


	/**
	 * Close modal trigger
	 */
	function closeModalTrigger( el ) {
		el.preventDefault();
		const iframe = document.querySelectorAll( 'iframe' );
		const videos = document.querySelectorAll( 'video' );

		/* Check if is video modal and stop video */
		if ( this.classList.contains( 'is-video-modal' ) ) {
			videos.forEach( item => item.pause() );
			iframe.forEach( iframe => {
				if ( iframe !== null ) {
					let iframeSrc = iframe.src;
					iframe.src    = iframeSrc;
				}
			} );
		}

		document.querySelectorAll( modal ).forEach( ( item ) => item.classList.remove( activeClass ) );
		// body.classList.remove( hiddenClass );
		body.classList.remove( modalOpenClass );
	}

	openModalBtn.forEach( item => item.addEventListener( 'click', openModalTrigger ) );
	closeModalBtn.forEach( item => item.addEventListener( 'click', closeModalTrigger ) );
};
